<template>
    <ModalComponent
        :name="'DeleteVoucher-' + voucher.id"
        title="Borrar Cupón"
        v-on:close="close"
    >
        <h2>¿Seguro que quieres borrar este cupón?</h2>

        <div slot="footer">
            <Button type="button" class="mr-3" @click="handleDelete" :disabled="loading">BORRAR</Button>
            <Button type="button" class="mr-3" @click="close" :disabled="loading">CANCELAR</Button>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['event_id', 'session_id', 'voucher'],
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            handleDelete() {
                const params = {
                    filters : {},
                    event_id: this.event_id,
                    session_id: this.session_id,
                    voucher_id: this.voucher.id
                };
                
                this.$store.dispatch(this.config.getVuexAlias('back.events.voucher.delete'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.close();
                }).finally(() => this.loading = false);

            },
            close(editado = false) {
                this.$emit('close', 'DeleteVoucher-' + this.voucher.id, editado);
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
